{
  "toast": {
    "checkYourEmailForASignInLink": "Check your email for a sign-in link",
    "ticketCreated": "Ticket created",
    "proofOfDeliveryConfirmed": "Proof of delivery confirmed",
    "replySent": "Reply sent",
    "ifRegisteredASignInLinkWasSent": "If registered, a sign-in link was sent"
  },
  "errors": {
    "couldNotSwitchPortal": "Could not switch portal",
    "couldNotLoadEmployeeProfile": "Could not load employee profile",
    "signInFailed": "Sign in failed",
    "couldNotSendSignInLink": "Could not send sign-in link",
    "linkInvalidOrExpired": "Link invalid or expired",
    "couldNotLoadDashboard": "Could not load dashboard",
    "couldNotOpenPortal": "Could not open portal",
    "couldNotLoadApplication": "Could not load application",
    "couldNotLoadProfile": "Could not load profile",
    "couldNotLoadTickets": "Could not load tickets",
    "failedToCreateTicket": "Failed to create ticket",
    "couldNotLoadDeliveries": "Could not load deliveries",
    "couldNotConfirmPod": "Could not confirm POD",
    "couldNotLoadPayroll": "Could not load payroll",
    "couldNotLoadLeaveBalances": "Could not load leave balances",
    "couldNotLoadRfqs": "Could not load RFQs",
    "couldNotLoadPurchaseOrders": "Could not load purchase orders",
    "couldNotLoadBills": "Could not load bills",
    "couldNotLoadPerformance": "Could not load performance",
    "sessionExpired": "Session expired",
    "replyFailed": "Reply failed",
    "enterOrganizationIdAndEmail": "Enter organization ID and email",
    "requestFailed": "Request failed",
    "invalidOrExpiredLink": "Invalid or expired link",
    "couldNotLoadSection": "Could not load {{section}}"
  },
  "pages": {
    "attendance": "Attendance",
    "leaveRequests": "Leave requests",
    "payslips": "Payslips",
    "partnerWorkspace": "Partner workspace",
    "collaborationAndDocuments": "Collaboration and documents",
    "interviews": "Interviews",
    "offerLetters": "Offer letters",
    "documents": "Documents",
    "onboardingTasks": "Onboarding tasks",
    "applicationStatus": "Application status",
    "invoices": "Invoices",
    "orders": "Orders",
    "payments": "Payments",
    "profile": "Profile",
    "supportTickets": "Support tickets",
    "myProfile": "My profile",
    "payroll": "Payroll",
    "leaveBalances": "Leave balances",
    "rfqs": "RFQs",
    "purchaseOrders": "Purchase orders",
    "vendorBills": "Vendor bills",
    "performanceScore": "Performance score",
    "payrollSummary": "Payroll summary",
    "proofOfDelivery": "Proof of delivery",
    "assignedDeliveries": "Assigned deliveries"
  },
  "labels": {
    "switchPortal": "Switch portal",
    "emailOrMobile": "Email or mobile",
    "password": "Password",
    "authenticatorCode": "Authenticator code",
    "subject": "Subject",
    "description": "Description",
    "describeYourIssue": "Describe your issue",
    "organizationId": "Organization ID",
    "email": "Email",
    "token": "Token",
    "closeMenu": "Close menu",
    "signOut": "Sign out",
    "menu": "Menu",
    "allPortals": "All portals",
    "organization": "Organization",
    "employeeWithCode": "Employee {{code}}",
    "delivery": "Delivery"
  },
  "empty": {
    "noAttendanceRecordsYet": "No attendance records yet.",
    "noLeaveRequestsYet": "No leave requests yet.",
    "noPayslipsAvailableYet": "No payslips available yet.",
    "noItemsYet": "No items yet.",
    "payrollInformationNotAvailableYet": "Payroll information is not available yet.",
    "noLeaveBalancesConfigured": "No leave balances configured.",
    "noDeliveriesAssigned": "No deliveries assigned."
  },
  "portals": {
    "EMPLOYEE": {
      "title": "Employee Portal",
      "subtitle": "Your workplace hub"
    },
    "CUSTOMER": {
      "title": "Customer Portal",
      "subtitle": "Orders, invoices & support"
    },
    "VENDOR": {
      "title": "Vendor Portal",
      "subtitle": "POs, RFQs & payments"
    },
    "CANDIDATE": {
      "title": "Candidate Portal",
      "subtitle": "Applications & onboarding"
    },
    "DELIVERY": {
      "title": "Delivery Portal",
      "subtitle": "Routes & proof of delivery"
    },
    "PARTNER": {
      "title": "Partner Portal",
      "subtitle": "Collaboration & documents"
    }
  },
  "portalNav": {
    "dashboard": "Dashboard",
    "profile": "Profile",
    "orders": "Orders",
    "invoices": "Invoices",
    "payments": "Payments",
    "support": "Support",
    "tickets": "Support",
    "documents": "Documents",
    "subscriptions": "Subscriptions",
    "notifications": "Notifications",
    "purchaseOrders": "Purchase Orders",
    "pos": "Purchase Orders",
    "rfqs": "RFQs",
    "quotations": "Quotations",
    "vendorBills": "Vendor Bills",
    "bills": "Vendor Bills",
    "performance": "Performance",
    "attendance": "Attendance",
    "leave": "Leave",
    "claims": "Claims",
    "payroll": "Payroll",
    "training": "Training",
    "approvals": "Approvals",
    "applications": "Applications",
    "interviews": "Interviews",
    "offerLetter": "Offer Letter",
    "offers": "Offer Letter",
    "onboarding": "Onboarding",
    "status": "Status",
    "deliveries": "Deliveries",
    "assigned": "Deliveries",
    "route": "Route",
    "proofOfDelivery": "Proof of Delivery",
    "pod": "Proof of Delivery"
  },
  "vendorPortal": {
    "empty": {
      "noBills": "No bills yet.",
      "noPurchaseOrders": "No purchase orders yet.",
      "noRfqs": "No RFQs yet.",
      "noScorecardData": "No scorecard data yet.",
      "useRfqsToSubmitQuotations": "Use RFQs to submit quotations."
    },
    "labels": {
      "compositeScore": "Composite score"
    }
  },
  "formActions": {
    "submitTicket": "Submit ticket"
  },
  "listActions": {
    "sendMagicLink": "Send magic link",
    "confirmPod": "Confirm POD"
  }
}
